



























import { Component, Prop, Provide, Vue } from 'vue-property-decorator';

import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

export enum EMode {
  Recommended = 'recommended',
  Additional = 'additional',
}

@Component({
  components: {
    ModuleVionicRecommendationsRecommendedOrthodics: () =>
      import('@/components/modules/vionic/recommendations/ModuleVionicRecommendationsRecommendedOrthodics.vue'),
    ModuleVionicRecommendationsAdditionalWedges: () =>
      import('@/components/modules/vionic/recommendations/ModuleVionicRecommendationsAdditionalWedges.vue'),
  },
})
export default class ModuleVionicPatientResultsRecommendations extends Vue {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;

  @Provide() mode: EMode = EMode.Recommended;
}
